import { useCallback, useMemo, useState, type ReactNode } from "react";
import { UploadLockContext } from "./UploadLockContext";

/**
 * Compte les envois de fichiers en cours pour que les formulaires ne puissent pas
 * être soumis tant qu'un fichier n'est pas entièrement reçu par le serveur : la
 * réponse de l'upload est ce qui rattache le fichier au formulaire, soumettre
 * avant revient à perdre le fichier.
 */
export function UploadLockProvider({ children }: { children: ReactNode }) {
  const [pending, setPending] = useState(0);

  const acquire = useCallback(() => {
    setPending((n) => n + 1);
    let released = false;
    return () => {
      if (released) return;
      released = true;
      setPending((n) => n - 1);
    };
  }, []);

  const value = useMemo(() => ({ pending, acquire }), [pending, acquire]);

  return (
    <UploadLockContext.Provider value={value}>
      {children}
    </UploadLockContext.Provider>
  );
}
